"use strict";
// Feature: address-geolocation, Task 5.5
//
// resolveReverseGeocode — pure planner for the display-only reverse-geocode
// read path. NEVER writes; NEVER treats the provider output as canonical
// (Req 7.2, 7.3).
//
// Owner scoping is applied because the target record is owner-scoped;
// this ensures a caller cannot ask "what's near {someone else's building}"
// without holding that tenancy.
Object.defineProperty(exports, "__esModule", { value: true });
exports.reverseGeocodeForLocation = exports.resolveReverseGeocode = void 0;
const models_1 = require("../models");
/**
 * Execute reverse-geocode lookup. Display-only — the caller must NOT
 * persist the result as a canonical `Address` (Req 7.3).
 *
 * Convenience helper `reverseGeocodeForLocation` accepts a stored
 * `GeoLocation` object directly.
 */
async function resolveReverseGeocode(input) {
    const { latitude, longitude, resolvedOwnerId, recordOwnerId, provider } = input;
    if (typeof resolvedOwnerId !== "string" || resolvedOwnerId.length === 0) {
        return { status: 403, error: "unresolved-owner" };
    }
    if (typeof recordOwnerId !== "string" ||
        recordOwnerId.length === 0 ||
        recordOwnerId !== resolvedOwnerId) {
        return { status: 404, error: "cross-owner" };
    }
    const validation = (0, models_1.validateCoordinate)(latitude, longitude);
    if (!validation.ok)
        return { status: 400, error: "invalid-coordinate" };
    let result;
    try {
        result = await provider.reverse(validation.latitude, validation.longitude);
    }
    catch {
        return { status: 502, error: "provider-error" };
    }
    if (result === null || result === undefined)
        return { status: 204 };
    return { status: 200, display: result };
}
exports.resolveReverseGeocode = resolveReverseGeocode;
/**
 * Convenience — accept a stored `GeoLocation` directly. Same guarantees.
 */
async function reverseGeocodeForLocation(location, resolvedOwnerId, recordOwnerId, provider) {
    if (!location)
        return { status: 400, error: "invalid-coordinate" };
    return resolveReverseGeocode({
        latitude: location.latitude,
        longitude: location.longitude,
        resolvedOwnerId,
        recordOwnerId,
        provider,
    });
}
exports.reverseGeocodeForLocation = reverseGeocodeForLocation;
